import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Subscriptions.css';

const Subscriptions = () => {
  const [subscriptions, setSubscriptions] = useState({ active: [], inactive: [] });
  const [loading, setLoading] = useState(true);
  const API_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    fetchSubscriptions();
  }, []);

  const fetchSubscriptions = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/user/subscriptions`, {
        withCredentials: true
      });
      setSubscriptions(response.data);
    } catch (error) {
      console.error('Failed to fetch subscriptions:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading subscriptions...</div>;
  }

  const hasSubscriptions = subscriptions.active.length > 0 || subscriptions.inactive.length > 0;

  return (
    <div className="subscriptions-page">
      <h1>My Subscriptions</h1>
      <p className="subtitle">Manage your microgreens subscriptions</p>

      {!hasSubscriptions ? (
        <div className="empty-state">
          <div className="empty-icon">🔄</div>
          <h3>No subscriptions yet</h3>
          <p>Subscribe to get fresh microgreens delivered weekly</p>
          <a href="/#subscription" className="btn-subscribe">View Plans</a>
        </div>
      ) : (
        <>
          {subscriptions.active.length > 0 && (
            <div className="subscription-section">
              <h2>✅ Active Subscriptions</h2>
              <div className="subscriptions-list">
                {subscriptions.active.map((sub) => (
                  <div key={sub.id} className="subscription-card active">
                    <div className="sub-header">
                      <div>
                        <h3>{sub.productName || 'Monthly Subscription'}</h3>
                        <span className="sub-id">#{sub.id.slice(0, 8).toUpperCase()}</span>
                      </div>
                      <span className="status-badge active">ACTIVE</span>
                    </div>
                    <div className="sub-details">
                      {sub.productName && (
                        <div className="detail-row">
                          <span>Variety:</span>
                          <strong>{sub.productName}</strong>
                        </div>
                      )}
                      <div className="detail-row">
                        <span>Price:</span>
                        <strong>₹{sub.price}/month</strong>
                      </div>
                      <div className="detail-row">
                        <span>Started:</span>
                        <strong>
                          {new Date(sub.startDate || sub.createdAt).toLocaleDateString('en-IN', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                          })}
                        </strong>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {subscriptions.inactive.length > 0 && (
            <div className="subscription-section">
              <h2>📋 Past Subscriptions</h2>
              <div className="subscriptions-list">
                {subscriptions.inactive.map((sub) => (
                  <div key={sub.id} className="subscription-card inactive">
                    <div className="sub-header">
                      <div>
                        <h3>{sub.productName || 'Monthly Subscription'}</h3>
                        <span className="sub-id">#{sub.id.slice(0, 8).toUpperCase()}</span>
                      </div>
                      <span className={`status-badge ${sub.status}`}>
                        {sub.status.toUpperCase()}
                      </span>
                    </div>
                    <div className="sub-details">
                      {sub.productName && (
                        <div className="detail-row">
                          <span>Variety:</span>
                          <strong>{sub.productName}</strong>
                        </div>
                      )}
                      <div className="detail-row">
                        <span>Price:</span>
                        <strong>₹{sub.price}/month</strong>
                      </div>
                      <div className="detail-row">
                        <span>Period:</span>
                        <strong>
                          {new Date(sub.createdAt).toLocaleDateString('en-IN', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                          })}
                        </strong>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Subscriptions;